import sunny from "../images/weather/sunny.svg";
import stormy from "../images/weather/stormy.svg";
import rainy from "../images/weather/rainy.svg";
import cloudy from "../images/weather/cloudy.svg";
import question from "../images/weather/questionmark.svg";
import React from "react";
import AlertMessage from "../components/alert/AlertMessage";
import {ContainerCriticality} from "../components/inputs/radioStyles";


export const getAdvancementColor = (advancement, stepBehavior = false) => {
    if (stepBehavior) {
        return "#3394F6"
    }
    if (advancement >= 50 && advancement <= 100) {
        return '#52D783'
    } else {
        return '#FFB400'
    }
}


export const sliceText = (value, maxChar) => {
    if (!!value && value.length > 0) {
        let text = value
        if (text.length > maxChar) {
            text = value.substring(0, maxChar) + "...";
        }
        return text
    } else {
        return "Pas de valeurs encore définies"
    }
}




// GET IMG
export const getWeatherImage = (weather) => {
    switch (weather) {
        case "sunny":
            return sunny;
        case "stormy":
            return stormy;
        case "rainy":
            return rainy;
        case "cloudy":
            return cloudy;
        default:
            return question;
    }
}
export const getImage = (img, defaultPicture) => {
    if (img !== null || img) {
        return `${process.env.REACT_APP_PROXYLESS_URL}${img}`
    } else {
        return defaultPicture
    }
}
// CRITICALITY
export const displayCriticality = (criticality) => {
    switch (criticality) {
        case 0:
            return (
                <ContainerCriticality>
                    <div className="dots green-dots "/>
                    <p className="fw-500 fs-09"> Faible </p>
                </ContainerCriticality>
            )
        case 1:
            return (
                <ContainerCriticality>
                    <div className="dots yellow-dots "/>
                    <p className="fw-500 fs-09"> Normale </p>
                </ContainerCriticality>
            )
        case 2:
            return (
                <ContainerCriticality>
                    <div className="dots red-dots "/>
                    <p className="fw-500 fs-09"> Élevée </p>
                </ContainerCriticality>
            )
        default:
            return <h5> Pas de criticité définie </h5>
    }
}
export const getDifferenceBetweenTwoNumber = (start_number, finish_number) => {
    if (Number.isInteger(start_number) && Number.isInteger(finish_number)) {
        return Math.abs(finish_number - start_number)
    } else {
        return <p> Il semblerait que les valeurs passées ne sont pas des nombres </p>
    }
}
export const getPercent = (totalValue, partialValue) => {
    return parseFloat((partialValue / totalValue) * 100).toFixed(2);
}

export const getReversePercent = (totalValue, partialValue) => {
    return Math.abs(parseFloat(100 -(partialValue / totalValue) * 100).toFixed(2))
}

//FOR THE REDUX ACTION
export const checkErrorMessage = (e) => {
    return (e.response && e.response.data && e.response.data.message) ||
        e.message ||
        e.toString()
}


export const displayAlert = (notSend, send) => {
    if (notSend) {
        return (
            <AlertMessage
                title={"Une erreur s'est produite !"}
                status={"alert"}
            />
        )
    } else if (send) {
        return (
            <AlertMessage
                title={"opération effectuée avec succès"}
                status={"success"}
            />
        )
    }
}

export const removeDuplicatesInArray = (array) => {
    return array.filter((value, index, self) =>
            index === self.findIndex((t) => (
                t.id === value.id
            ))
    )
}

export const getRandomKeyForChild = () => {
    return Math.floor(Math.random() * 999999);
}

